/* External */
import { memo, useEffect } from 'react';
import PropTypes from 'prop-types';

/* Components */
import FocusableButton from '../FocusableButton';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';

function ContentModal({
  logo,
  title,
  description,
  textButton,
  isModalShown,
  onEnterPress,
  realFocusKey,
  setFocus,
}) {
  const buttonFocusKey = `${realFocusKey}_button`;

  useEffect(() => {
    if (isModalShown) {
      setFocus(buttonFocusKey);
    }
  }, [setFocus, buttonFocusKey, isModalShown]);

  return (
    <div className="dtv-html5-c-gran-hermano-modal__content">
      <img loading="lazy" decoding="async" src={logo} className="dtv-html5-c-gran-hermano-modal__logo" alt="logo" />
      <h1 className="dtv-html5-c-gran-hermano-modal__title">
        {title}
      </h1>
      <p className="dtv-html5-c-gran-hermano-modal__description">
        {description}
      </p>
      <FocusableButton
        className="dtv-html5-c-gran-hermano-modal__button"
        onEnterPress={onEnterPress}
        focusKey={buttonFocusKey}
        primary
        bordered
      >
        {textButton}
      </FocusableButton>
    </div>
  );
}

ContentModal.propTypes = {
  logo: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  textButton: PropTypes.node.isRequired,
  isModalShown: PropTypes.bool.isRequired,
  onEnterPress: PropTypes.func.isRequired,
  realFocusKey: PropTypes.string.isRequired,
  setFocus: PropTypes.func.isRequired,
};

export default memo(withInteractiveFocusable()(memo(ContentModal)));
